<template>
  <div class="top">
    <div class="topdiv">
      <span
        class="font-time"
      >{{time.year}}&nbsp;年 {{ time.month }}&nbsp;月{{ time.day }}&nbsp;日&nbsp;&nbsp;{{ todos[time.week] }}&nbsp;&nbsp;{{ time.hours }}:{{ time.minutes }}</span>
      <ul class="menu2">
        <li>
          <el-dropdown class="dropdown">
            <span class="el-dropdown-link dropdown-link">
              <!-- <i class="Img">
                <img src="../../assets/logo.png">
              </i>-->
              <!-- <span>{{per.name}}</span> -->
              <el-button
                style="background-color: #FE6565;color:#fff;border-radius: 10px;"
              >{{per.name}}</el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button type="text" @click="changePassword">修改密码</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li class="exit">
          <router-link to="/" style="color: black">
            <!-- <i class="fa fa-sign-in" aria-hidden="true" style="color: black"></i>退出 -->
            <el-button
              aria-hidden="true"
              style="background-color: #3C6EA9;color:#fff;border-radius: 10px;"
            >退出</el-button>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<style type="text/css" scoped>
.topdiv {
  height: 70px;
  line-height: 70px;
  /* background-color: #95b2d4; */
  background-color: #f6f7fb;
}
.top {
  line-height: 50px;
  background: black;
}
.top .font-time {
  margin-left: 15px;
  float: left;
  color: black;
}

.top .font-time,
.top .dropdown,
.top .menu2 li {
  color: black;
  font-size: 14px;
}

.top .menu2 {
  text-align: center;
  float: right;
  margin-right: 60px;
}

.top .menu2 li {
  display: inline-block;
  list-style: none;
  text-align: center;
  margin-left: 30px;
}

.top .menu2 .exit a {
  text-decoration: none;
  color: #666;
  font-size: 14px;
}

.top .menu2 li i {
  margin-right: 10px;
}

.top img {
  width: 30px;
  height: 30px;
  vertical-align: middle; /*使得图片垂直居中*/
}

.top .dropdown-link {
  cursor: pointer;
}
</style>
<script>
import store from "../../store";
export default {
  data() {
    return {
      dialogVisible: true,
      per: store.state.per,
      time: {
        month: 0,
        day: 0,
        week: 0,
        hours: 0,
        minutes: 0,
        year: 0
      },
      todos: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      timer: null
    };
  },
  methods: {
    changePassword: function() {
      this.$emit("changePassword", this.dialogVisible);
    },
    updateTime() {
      let that = this;
      let date = new Date();
      that.time.year = date.getFullYear();
      that.time.month = date.getMonth() + 1;
      that.time.day = date.getDate();
      that.time.week = date.getDay();
      that.time.hours = date.getHours();
      if (date.getMinutes() < 10) {
        that.time.minutes = "0" + date.getMinutes();
      } else {
        that.time.minutes = date.getMinutes();
      }
    }
  },
  created() {
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>


// WEBPACK FOOTER //
// topBars.vue?ef0b98fa